<!--
 * @Author: your name
 * @Date: 2021-01-07 09:49:29
 * @LastEditTime: 2021-11-01 14:08:55
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vue3-element-admin\src\App.vue
-->
<template>
    <!-- <router-view v-slot="{ Component }">
  <keep-alive exclude="GardenReport">
    <component :is="Component" />
  </keep-alive>
</router-view> -->
    <el-config-provider :locale="elementLocale">
    <!-- keep-alive 必须常驻；用内部 component 的 v-if 区分是否缓存，避免切到非缓存页时整棵 keep-alive 被销毁 -->
    <router-view v-slot="{ Component }">
        <keep-alive>
            <component
                :is="Component"
                v-if="Component && route.meta.keepAlive"
                :key="route.name"
            />
        </keep-alive>
        <component
            :is="Component"
            v-if="Component && !route.meta.keepAlive"
            :key="route.name"
        />
    </router-view>


    <Tabbar class="tabbar" route fixed v-show="showTab" active-color="#2199F8" inactive-color="#898989">
        <!-- 托管农户：首页、农事档案、农事记录 -->
        <!-- <template v-if="userType == 2"> -->
            <tabbar-item replace to="/growth_report">
                <span>{{ t("tabbar.situationAssessment") }}</span>
                <template #icon="props">
                    <img
                        :src="
                            props.active
                                ? require('@/assets/img/tab_bar/home-active.png')
                                : require('@/assets/img/tab_bar/home.png')
                        "
                    />
                </template>
            </tabbar-item>
            <tabbar-item replace to="/diagnosis_report">
                <span>{{ t("tabbar.diagnosisReport") }}</span>
                <template #icon="props">
                    <img
                        :src="
                            props.active
                                ? require('@/assets/img/tab_bar/baogao-active.png')
                                : require('@/assets/img/tab_bar/baogao.png')
                        "
                    />
                </template>
            </tabbar-item>
            <tabbar-item replace to="/agri_file">
                <span>{{ t("tabbar.agriFile") }}</span>
                <template #icon="props">
                    <img
                        :src="
                            props.active
                                ? require('@/assets/img/tab_bar/tree-active.png')
                                : require('@/assets/img/tab_bar/tree.png')
                        "
                    />
                </template>
            </tabbar-item>
            <!-- <tabbar-item replace to="/agri_record">
                <span>{{ t("tabbar.agriRecord") }}</span>
                <template #icon="props">
                    <img
                        :src="
                            props.active
                                ? require('@/assets/img/tab_bar/task-active.png')
                                : require('@/assets/img/tab_bar/task.png')
                        "
                    />
                </template>
            </tabbar-item> -->
            <tabbar-item replace to="/work_execute">
                <span>{{ t("tabbar.schedule") }}</span>
                <template #icon="props">
                    <img
                        :src="
                            props.active
                                ? require('@/assets/img/tab_bar/task-active.png')
                                : require('@/assets/img/tab_bar/task.png')
                        "
                    />
                </template>
            </tabbar-item>
        <!-- </template> -->

        <!-- 普通农户：首页、农事服务、用户管理、个人中心（保留原逻辑） -->
        <!-- <template v-else-if="userType == 1">
            <tabbar-item replace to="/home" v-if="curRole == 0 || curRole == 2">
                <span>{{ $t('首页') }}</span>
                <template #icon="props">
                    <img
                        :src="
                            props.active
                                ? require('@/assets/img/tab_bar/home-active.png')
                                : require('@/assets/img/tab_bar/home.png')
                        "
                    />
                </template>
            </tabbar-item>
            <tabbar-item replace to="/task_condition">
                <span>{{ $t('农事服务') }}</span>
                <template #icon="props">
                    <img
                        :src="
                            props.active
                                ? require('@/assets/img/tab_bar/service-active.png')
                                : require('@/assets/img/tab_bar/service.png')
                        "
                    />
                </template>
            </tabbar-item>
            <tabbar-item replace to="/user">
                <span>{{ $t('用户管理') }}</span>
                <template #icon="props">
                    <img
                        :src="
                            props.active
                                ? require('@/assets/img/tab_bar/user-active.png')
                                : require('@/assets/img/tab_bar/user.png')
                        "
                    />
                </template>
            </tabbar-item>
            <tabbar-item replace to="/mine">
                <span>{{ $t('个人中心') }}</span>
                <template #icon="props">
                    <img
                        :src="
                            props.active
                                ? require('@/assets/img/tab_bar/mine-active.png')
                                : require('@/assets/img/tab_bar/mine.png')
                        "
                    />
                </template>
            </tabbar-item>
        </template> -->
    </Tabbar>

    <!-- 开启底部安全区适配 -->
    <number-keyboard safe-area-inset-bottom />

    <!-- 异常巡检识别中：右上角固定 loading + 文案 -->
    <div v-if="showInspectLoading" class="inspect-loading-fixed">
        <loading type="spinner" color="#fff" size="18px" />
        <span class="inspect-loading-fixed__text">识别中</span>
    </div>

    <!-- 异常巡检成功：全局弹窗，任意页面可显示 -->
    <tip-popup
        v-model:show="showInspectSuccessPopup"
        type="executeSuccess"
        text="您已上传成功"
        text2="诊断报告已生成"
        buttonText="完成"
    />
    </el-config-provider>
</template>

<script setup>
import { NumberKeyboard, Tabbar, TabbarItem, Loading } from "vant";
import { nextTick, watch, onMounted, onBeforeUnmount, ref, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { NH, NZ, EXPERT } from "@/common/user_role";
import zhCn from "element-plus/es/locale/lang/zh-cn";
import en from "element-plus/es/locale/lang/en";
import { useI18n } from "@/i18n";
import eventBus from "@/api/eventBus";
import tipPopup from "@/components/popup/tipPopup.vue";

const { t, locale } = useI18n();
const store = useStore();
const elementLocale = computed(() => (locale.value === "en" ? en : zhCn));
const route = useRoute();
const router = useRouter();

/** 与 growthTrack 异常巡检约定：识别中全局悬浮 loading / 成功全局弹窗 */
const INSPECT_PENDING_KEY = "AGRI_INSPECT_PENDING";
const INSPECT_PENDING_EVENT = "inspect-upload-pending";
const INSPECT_DONE_EVENT = "inspect-upload-done";
const INSPECT_SUCCESS_KEY = "AGRI_INSPECT_UPLOAD_SUCCESS";
const INSPECT_SUCCESS_EVENT = "inspect-upload-success";
const showInspectLoading = ref(false);
const showInspectSuccessPopup = ref(false);

function openInspectLoading() {
    showInspectLoading.value = true;
}

function closeInspectLoading() {
    sessionStorage.removeItem(INSPECT_PENDING_KEY);
    showInspectLoading.value = false;
}

function tryShowInspectLoading() {
    if (sessionStorage.getItem(INSPECT_PENDING_KEY) !== "1") return;
    openInspectLoading();
}

function openInspectSuccessPopup() {
    closeInspectLoading();
    sessionStorage.removeItem(INSPECT_SUCCESS_KEY);
    showInspectSuccessPopup.value = true;
}

function tryShowInspectSuccessPopup() {
    if (sessionStorage.getItem(INSPECT_SUCCESS_KEY) !== "1") return;
    openInspectSuccessPopup();
}

// 首页loading加载完才显示底部导航栏
const showTab = ref(false);
// 0: 农户, 1: 专家, 2:农资农服
const curRole = ref(0);
// USER_TYPE: 1 普通农户，2 托管农户
const userType = ref("2");

// 获取用户是否为托管农户，并缓存 USER_TYPE（与 dev_login.vue 逻辑一致）
const fetchUserType = async () => {
    
    userType.value = "2";
    localStorage.setItem("USER_TYPE", "2");

    // // 检查是否有 token，没有 token 则不调用接口
    // const token = store.state.app.token || localStorage.getItem("token");
    // if (!token) {
    //     // 没有 token 时使用缓存的值
    //     userType.value = localStorage.getItem("USER_TYPE") || "1";
    //     return;
    // }

    // try {
    //     const { data } = await VE_API.farm.userFarmSelectOption({ userType: 2 });
    //     if (Array.isArray(data) && data.length > 0) {
    //         // 有托管农户数据
    //         userType.value = "2";
    //         localStorage.setItem("USER_TYPE", "2");
    //     } else {
    //         userType.value = "1";
    //         localStorage.setItem("USER_TYPE", "1");
    //     }
    // } catch (error) {
    //     // 请求失败时保留默认值
    //     userType.value = localStorage.getItem("USER_TYPE") || "1";
    // }
};

let tabBarHeight = 0;

// 监听 token 变化，当有 token 时调用接口获取用户类型
watch(
    () => store.state.app.token,
    (newToken) => {
        if (newToken) {
            fetchUserType();
        }
    },
    { immediate: true }
);

onMounted(() => {
    tryShowInspectLoading();
    tryShowInspectSuccessPopup();
    eventBus.on(INSPECT_PENDING_EVENT, openInspectLoading);
    eventBus.on(INSPECT_DONE_EVENT, closeInspectLoading);
    eventBus.on(INSPECT_SUCCESS_EVENT, openInspectSuccessPopup);

    setTimeout(() => {
        curRole.value = store.state.app.curRole;
        if (route.meta.showTabbar) {
            showTab.value = true;
        }
        nextTick(() => {
            const tabBarElement = document.querySelector(".van-tabbar");
            if (tabBarElement) {
                tabBarHeight = tabBarElement.offsetHeight;
                localStorage.setItem("tabBarHeight", tabBarHeight);
                store.commit("home/SET_TAB_BAR_HEIGHT", tabBarHeight);
            }
        });
    }, 500);
});

onBeforeUnmount(() => {
    eventBus.off(INSPECT_PENDING_EVENT, openInspectLoading);
    eventBus.off(INSPECT_DONE_EVENT, closeInspectLoading);
    eventBus.off(INSPECT_SUCCESS_EVENT, openInspectSuccessPopup);
});

watch(
    () => route.name,
    (newName, oldName) => {
        // 在这里执行你的自定义逻辑
        showTab.value = false;
        if (route.meta.showTabbar) {
            showTab.value = true;
        }
        nextTick(() => {
            const tabBarElement = document.querySelector(".van-tabbar");
            if (tabBarElement) {
                tabBarHeight = tabBarElement.offsetHeight;
                localStorage.setItem("tabBarHeight", tabBarHeight);
                store.commit("home/SET_TAB_BAR_HEIGHT", tabBarHeight);
            }
            curRole.value = store.state.app.curRole
        });
    },
    { immediate: false }
);
</script>
<style lang="scss" scoped>
.tabbar {
    position: fixed;
    pointer-events: all;
    z-index: 9999;
}

.inspect-loading-fixed {
    position: fixed;
    top: 10px;
    right: 12px;
    z-index: 10000;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2px;
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background: #1989fa;
    box-shadow: 0 4px 12px rgba(25, 137, 250, 0.35);
    pointer-events: none;

    &__text {
        font-size: 11px;
        line-height: 14px;
        color: #fff;
        font-weight: 500;
        white-space: nowrap;
    }
}
</style>
